// @mui
import { Stack, Button, Typography, Box } from '@mui/material';
// auth
import { useAuthContext } from '../../../auth/useAuthContext';
// locales
import { useLocales } from '../../../locales';
// routes
import { PATH_DOCS } from '../../../routes/paths';
import projectJson from '../../../json/project/projectJson';
import { version } from '../../../config';

// ----------------------------------------------------------------------

export default function NavDocs() {
    const { user } = useAuthContext();

    const { translate } = useLocales();

    return (
        <Stack
            spacing={3}
            sx={{
                px: 5,
                pb: 5,
                mt: 10,
                width: 1,
                display: 'block',
                textAlign: 'center',
            }}
        >
            <Box component="img" src={projectJson.logoShadapps} />
            <Typography color="text.disabled" variant="caption">
                version {version}
            </Typography>
        </Stack>
    );
}
